export default __webpack_public_path__ + "static/media/solteiroduplo_6.e9b0df1d.jpg";